import ApiValues from '../url/apiurl'
import labels from '../../utils/constants/labels';
import Networking from '../../utils/api/apiaccess';
function getInsuranceAddbank(data) {
    return Networking.PostApi(ApiValues.addInsuranceBank, data).then(result => { return result })
        .catch(function (error) {
            return { "status": "F", "message": labels.messages.apierror }
        });
}
export default getInsuranceAddbank